// @flow

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import yellow from '@material-ui/core/colors/yellow';

import history from '../util/history';
import { WebRoutes } from '../apply-routes';

const styles = theme => ({
  container: {
    padding: '10px',
    backgroundColor: yellow[100],
    textAlign: 'center',
  },
});

type Props = {
  classes: Object,
  referral: ReferralType,
  jobHash: string,
  actions: {
    clearReferral: Function,
  },
};

type State = {
  confirmed: boolean,
};

class ReferralInfo extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      confirmed: false,
    };
  }

  confirm = () => {
    this.setState({
      confirmed: true,
    });
  };

  newApplication = () => {
    history.push(WebRoutes.jobApplicationRouteUnversioned(this.props.jobHash));
  };

  render() {
    const { classes, referral } = this.props;
    if (this.state.confirmed) {
      return null;
    }

    const {Contact, Employee: referringEmployee} = referral;
    if (!Contact) {
      return null;
    }

    const referrerName = referringEmployee ? `${referringEmployee.Contact.Person.firstName} ${referringEmployee.Contact.Person.lastName}` : referral.referrerName;

    if (!referrerName) {
      return null;
    }

    return (
      <div className={classes.container}>
        <Typography variant="subtitle1">
          Hi, {Contact.Person.firstName}! {referrerName} referred you for this job.
        </Typography>
        <Grid container justify="center" alignItems="center">
          <Grid item>
            <Button
              color="primary"
              onClick={this.newApplication}
            >
              Not Me
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="secondary"
              onClick={this.confirm}
            >
              Yes, that&apos;s me
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(ReferralInfo);
